"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.auth0 = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

// TODO: Map out this user properly.
var auth0 = function auth0(client) {
  return {
    type: 'auth0',
    client: client,
    restoreAuthState: function () {
      var _restoreAuthState = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _context;

        var _yield$client$handleR, appState;

        return _regenerator.default.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(0, _includes.default)(_context = window.location.search).call(_context, 'code=')) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return client.handleRedirectCallback();

              case 3:
                _yield$client$handleR = _context2.sent;
                appState = _yield$client$handleR.appState;
                window.history.replaceState({}, document.title, appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));

      function restoreAuthState() {
        return _restoreAuthState.apply(this, arguments);
      }

      return restoreAuthState;
    }(),
    login: function () {
      var _login = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", client.loginWithRedirect());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee2);
      }));

      function login() {
        return _login.apply(this, arguments);
      }

      return login;
    }(),
    logout: function logout(options) {
      return client.logout(options);
    },
    getToken: function () {
      var _getToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", client.getTokenSilently());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee3);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }(),
    getUserMetadata: function () {
      var _getUserMetadata = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var user;
        return _regenerator.default.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return client.getUser();

              case 2:
                user = _context5.sent;
                return _context5.abrupt("return", user || null);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4);
      }));

      function getUserMetadata() {
        return _getUserMetadata.apply(this, arguments);
      }

      return getUserMetadata;
    }()
  };
};

exports.auth0 = auth0;